import { Link, useNavigate } from "react-router-dom"
import UiButton2 from "./ui_button2"
import { useContext } from "react"
import { AppContext } from "./context"
import UiSpinner from "./ui_spinner"

const SidebarAccount = ({ path }) => {

	let { neonUser } = useContext(AppContext)
	let navigate = useNavigate()


	if (!neonUser.user || !neonUser.user.role) return (
		<div className="d-flex justify-content-center">
			<UiSpinner color="white" />
		</div>
	)

	return (

		<div className="d-flex flex-column gap-3">

			<UiButton2 text={"Back"} submit={() => navigate(["owner", "admin"].includes(neonUser.role) ? "/brand" : "/")} />

			{["owner"].includes(neonUser.role) &&
				<Link to="/account" style={{ textDecoration: "none" }}>

					<div className="d-flex gap-2">

						{path == ("/account") || path == ("/") && neonUser.role == "normal" ?
							<div style={{ width: 35, height: 35 }} className="bg-white p-1 rounded opacity-75">
								<img src={"/src/profile-on.png"} className="w-100 opacity-100" />
							</div>
							:
							<div className="p-1 rounded off-icon">
								<img src={"/src/profile-off.png"} className="w-100" />
							</div>
						}

						<p className="text-white fs-6 m-0 align-self-center">Your Profile</p>

					</div>
				</Link>
			}


			<Link to="/account/change-pass" style={{ textDecoration: "none" }}>

				<div className="d-flex gap-2">

					{
					// path.includes("/change-pass") || ["normal", "editor", "admin"].includes(neonUser.user.role) ?
					path.includes("/change-pass") ?
						<div style={{ width: 35, height: 35 }} className="bg-white p-1 rounded opacity-75">
							<img src={"/src/pass.png"} className="w-100 opacity-100" />
						</div>
						:
						<div className="p-1 rounded off-icon">
							<img src={"/src/pass-off.png"} className="w-100" />
						</div>
					}

					<p className="text-white fs-6 m-0 align-self-center">Change Password</p>

				</div>
			</Link>

			<Link to="/account/mfa" style={{ textDecoration: "none" }}>

				<div className="d-flex gap-2">

					{path.includes("/mfa") ?
						<div style={{height: 35, width: 35}}className="text-center bg-white d-flex  justify-content-center rounded opacity-75">
							{/* <img src={"/src/pass.png"} className="w-100 opacity-100" />
							 */}
							 <i className="bi bi-shield-plus align-self-center fs-4" style={{color: " #CB3974"}}></i>
						</div>
						:
						<div className=" rounded off-icon text-center d-flex justify-content-center">
							{/* <img src={"/src/pass-off.png"} className="w-100" />
							 */}
							 <i className="bi bi-shield-plus text-white align-self-center fs-4"  ></i>
						</div>
					}

					<p className="text-white fs-6 m-0 align-self-center">Multifactor Auth</p>

				</div>
			</Link>
			{/* {neonUser && ["owner"].includes(neonUser.role) &&
				<Link to="/account/subscription" style={{ textDecoration: "none" }}>

					<div className="d-flex gap-2">

						{path.includes("/subscription") ?
							<div style={{ width: 35, height: 35 }} className="bg-white p-1 rounded opacity-75">
								<img src={"/src/subs-on.png"} className="w-100 opacity-100" />
							</div>
							:
							<div className="p-1 rounded off-icon">
								<img src={"/src/subs.png"} className="w-100" />
							</div>
						}

						<p className="text-white fs-6 m-0 align-self-center">Subscription</p>

					</div>
				</Link>
			} */}



			{neonUser && ["dev"].includes(neonUser.role) &&
				<Link to="/impersonate" style={{ textDecoration: "none" }}>

					<div className="d-flex gap-2">

						{path.includes("/impersonate") ?
							<div style={{ width: 35, height: 35 }} className="bg-white p-1 rounded opacity-75">
								<img src={"/src/profile-on.png"} className="w-100 opacity-100" />
							</div>
							:
							<div className="p-1 rounded off-icon">
								<img src={"/src/profile-off	.png"} className="w-100" />
							</div>
						}

						<p className="text-white fs-6 m-0 align-self-center">Impersonate</p>

					</div>
				</Link>
			}

		</div>
	)
}

export default SidebarAccount